type LogLevel = 'log' | 'info' | 'debug' | 'warn' | 'error'

// Define custom type to handle 'success' separately
type CustomLogLevel = LogLevel | 'success'

const logMessage = (level: CustomLogLevel, prefix: string, ...data: any[]) => {
  if (import.meta.env.DEV) {
    // Handle 'success' as a special case since it's not a native console method
    if (level === 'success') {
      console.log(`%c${prefix}`, 'color: green; font-weight: bold', ...data)
    } else {
      console[level](prefix, ...data)
    }
  }
}

export const log = (...data: any[]) => logMessage('log', '', ...data)
export const logInfo = (...data: any[]) => logMessage('info', 'ℹ️ Info:', ...data)
export const logDebug = (...data: any[]) => logMessage('debug', '🔍 Debug:', ...data)
export const logWarn = (...data: any[]) => logMessage('warn', '⚠️ Warning:', ...data)
export const logError = (...data: any[]) => logMessage('error', '🔥 Error:', ...data)
export const logSuccess = (...data: any[]) => logMessage('success', '✅ Success:', ...data)
